import AdminSidebar from "../../components/AdminC/AdminSidebar";
import AdminTopbar from "../../components/AdminC/AdminTopbar";
import AdminLogout from "../../components/AdminC/AdminLogout";
import "../../App.css";
import { useContext } from "react";
import { AdminContext } from "../../context/AdminContext";
import { Outlet } from "react-router-dom";

function AdminDashboard() {
  const { isSidebarOpen } = useContext(AdminContext);
  return (
    <div className={`dashboard-wrapper ${isSidebarOpen ? "sidebar-open" : ""}`}>
      <div className="dashboard-outer d-flex">
        {isSidebarOpen && <AdminSidebar />}
        <div className="flex-grow-1 d-flex flex-column dashboard_right_box">
          <AdminTopbar />
          <Outlet />
        </div>
      </div>
      <AdminLogout />
    </div>
  );
}

export default AdminDashboard;
